var _a;
export var CommonConstants = {
    USER_AGENT: (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent,
};
export var PathType;
(function (PathType) {
    PathType[PathType["JS"] = 0] = "JS";
    PathType[PathType["JSON_PATCH"] = 1] = "JSON_PATCH";
})(PathType || (PathType = {}));
export var moveOperation;
(function (moveOperation) {
    moveOperation[moveOperation["DOWN"] = -1] = "DOWN";
    moveOperation[moveOperation["UP"] = 1] = "UP";
    moveOperation[moveOperation["TOP"] = 2] = "TOP";
    moveOperation[moveOperation["BOTTOM"] = 0] = "BOTTOM";
})(moveOperation || (moveOperation = {}));
export var MoveOperation;
(function (MoveOperation) {
    MoveOperation[MoveOperation["DOWN"] = -1] = "DOWN";
    MoveOperation[MoveOperation["UP"] = 1] = "UP";
    MoveOperation[MoveOperation["TOP"] = 2] = "TOP";
    MoveOperation[MoveOperation["BOTTOM"] = 0] = "BOTTOM";
})(MoveOperation || (MoveOperation = {}));
export var COMMON_METADATA = 'COMMON_METADATA';
export var NON_CORE_DATA = 'NON_CORE_DATA';
export var CORE_DATA = 'CORE_DATA';
export var NON_ENUMERABLE = 'NON_ENUMERABLE';
export var ENUMERABLE = 'ENUMERABLE';
export var TRANSACTION_TRACE = 'TRANSACTION_TRACE';
export var DUR_PATH = 'cBhvr.cTn.dur';
export var DELAY_PATH = 'cBhvr.cTn.stCondLst[0].delay';
export var ChangeCause;
(function (ChangeCause) {
    ChangeCause[ChangeCause["Operation"] = 0] = "Operation";
    ChangeCause[ChangeCause["Recv"] = 1] = "Recv";
    ChangeCause[ChangeCause["UndoRedo"] = 2] = "UndoRedo";
    ChangeCause[ChangeCause["Merge"] = 3] = "Merge";
    ChangeCause[ChangeCause["Memory"] = 4] = "Memory";
})(ChangeCause || (ChangeCause = {}));
export var ImagePath;
(function (ImagePath) {
    ImagePath["backgroundPath"] = "backgroundPath";
    ImagePath["foregroundPath"] = "foregroundPath";
    ImagePath["backupPath"] = "backupPath";
})(ImagePath || (ImagePath = {}));
export var ORPHAN_INDEX = 4294967295;
//# sourceMappingURL=common-constants.js.map